module.exports = __webpack_public_path__ + "img/full6-min.53c9a3e5.png";